export const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const customTitleStyles = {
  display: 'flex',
  alignItems: 'center',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
};

export const customTitleWrapperStyles = {
  marginBottom: '40px',
};

export const customDividerStyles = {
  color: ({ palette }) => palette.border.default,
  marginBottom: '24px',
};

export const headlineIconWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  aspectRatio: 1,
  height: '24px',
  borderRadius: '50%',
  backgroundColor: ({ palette }) => palette.blue.soft,
  marginRight: '8px',
  color: ({ palette }) => palette.icon.info,

  '& > svg': {
    width: '18px',
    height: '18px',
  },
};

export const customIconWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  aspectRatio: 1,
  height: '24px',
  borderRadius: '50%',
  backgroundColor: ({ palette }) => palette.blue.soft,
  marginRight: '8px',
};

export const customIconStyles = {
  display: 'flex',
  color: ({ palette }) => palette.icon.info,
  marginRight: 0,

  '& > svg': {
    width: '18px',
    height: '18px',
  },
};
